
/**
 * @file 发送展示统计
 * @author dafo<huanghouin@baijiahulian.com>
 * @module module/scroll
 */
/* eslint-disable camelcase */
import request from './util/request';
import throttle from './util/throttle';
import configurable from './util/configurable';
import {
    parse,
    camelToUnder
} from './util/json';
import {
    on,
    off,
    isInViewPort
} from './util/dom';
import {
    trackID,
    getUserID,
    Config
} from './util/config';
import warnForbiddenKeys from './util/forbiddenWords';
import metric from './metric';

/**
 * 屏蔽点击上报的标记属性名
 *
 * @const {string}
 */
const NO_LOG_FLAG = 'data-habo-noscroll';

/**
 * 监听滚动上报的 CSS class
 *
 * @const {string}
 */
const SCROLL_CLASS = '.habo-scroll-observe';

/**
 * 收集点击上报所必需参数的属性名
 *
 * @const {string}
 */
const LOG_FLAG_N_PARAMS = 'data-habo-params';


/**
 * 滚动可见后事件上报
 *
 * @function
 * @param {Object} json 要上报的数据
 * @param {Function=} callback 上报后的回调
 */
const report = configurable((json, callback) => {
    const {
        event_id = '',
        logger_id,
        user_id = getUserID(),
        index,
        ...rest
    } = camelToUnder(json);

    // 处理多个 event id 的情况，第一个为点击事件的 id，第二个为滚动事件的 id
    const [clickEventID, scrollEventID = clickEventID] = String(event_id).split(',');

    // 上报数据
    const scrollLogData = {
        // 当前页面，与 PV 上报字段名保持一致
        page_url: location.href,

        // 事件 id
        event_id: scrollEventID,

        // 对应的后端日志 id
        logger_id,

        // 登录用户 id
        user_id,

        // 对于列表项中的展示 ，需要该字段区分是第几个列表项，从 0 开始
        index,

        // 用户的唯一标识，由后端生成写到 cookie 中
        track_id: trackID,

        ...rest
    };
    warnForbiddenKeys(scrollLogData);
    request(Config.VERB)(`${Config.GS}`, scrollLogData, callback);

    // 自动上报点击指标数据到轻舟
    metric({
        ...scrollLogData,
        metric: 'scroll'
    });
}, {});


/**
 * 滚动事件处理
 *
 * @function
 */

const observe = throttle(event => {
    const elements = document.querySelectorAll(SCROLL_CLASS);
    // 低级浏览器 的 HTMLCollection 不支持 forEach
    [].forEach.call(elements, el => {
        // 最外层的滚动事件的event.target在chrome里是window，在ie里是document，都没有contains方法
        const isDescendant = event.target === window || event.target === document || event.target.contains(el);
        if (!el.hasAttribute(NO_LOG_FLAG) && isInViewPort(el) && isDescendant) {
            report(parse(el.getAttribute(LOG_FLAG_N_PARAMS)));

            el.setAttribute(NO_LOG_FLAG, '');
        }
    });
}, 50);

report.trigger = el => observe({target: el || window});

const win = typeof window !== 'undefined' && window;

/**
 * 解除相关事件的绑定
 */
const destroy = () => {
    off(win, 'scroll', observe, true);
    off(win, 'unload', destroy);
};

on(win, 'scroll', observe, true);
on(win, 'unload', destroy);


export default report;

